<template>
  <div class="markBox">
    <div class="mark">
      <div class="markItem">较差</div>
      <div class="markItem">中等</div>
      <div class="markItem">良好</div>
      <div class="markItem">优秀</div>
      <div class="markStar">0</div>
      <div class="markEnd">100</div>
      <div
        :class="
          item.status == '较差'
            ? 'markIcon'
            : item.status == '中等'
            ? 'markIcon markIconZ'
            : item.status == '良好'
            ? 'markIcon markIconL'
            : 'markIcon markIconY'
        "
      >
        <span>{{ item.value }}</span>
        <img :src="colorsImg[item.level - 1]" />
      </div>
    </div>
    <div class="markText">
      <div class="markTextItem" v-for="(item, index) in textList" :key="index">
        <span
          class="span1"
          :style="{
            background:
              item.status == '较差'
                ? '#D45353'
                : item.status == '中等'
                ? '#F1BE33'
                : item.status == '良好'
                ? '#9EF133'
                : '#28D200',
          }"
          >{{ item.status }}</span
        >
        <span class="span2">{{ item.pppp }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['item'],
  data () {
    return {
      lev: 0,
      colorsImg: [
        require('../../../assets/image/anxin/jiantou1.png'),
        require('../../../assets/image/anxin/jiantou2.png'),
        require('../../../assets/image/anxin/jiantou3.png'),
        require('../../../assets/image/anxin/jiantou4.png'),
      ],
      textList: [
        {
          status: '较差',
          pppp: '≤60分，功能中度异常，需及时干预或就医'
        },
        {
          status: '中等',
          pppp: ' 61~74分，存在轻度功能异常，建议及时健康干预'
        },
        {
          status: '良好',
          pppp: ' 75~84分，功能轻微下降，需定期健康监测 '
        },
        {
          status: '优秀',
          pppp: '85~100分，持续保持健康生活习惯'
        }
      ]
    }
  },
  watch: {
    item (newVal) {
      console.log(newVal)
    }
  },
  created () {

  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
.markBox {
  padding: 0 30px;
}
.mark {
  width: 100%;
  margin: 80px auto 0px auto;
  position: relative;
  height: 80px;
  .markStar {
    position: absolute;
    left: 0;
    bottom: 66px;
    font-size: 24px;
  }
  .markEnd {
    position: absolute;
    right: 0;
    bottom: 66px;
    font-size: 24px;
  }
  .markIcon {
    position: absolute;
    width: 25%;
    text-align: center;
    color: #d45353;
    bottom: 85px;
    img {
      width: 19px;
      height: 29px;
    }
    span {
      display: inline-block;
      width: 100%;
      font-size: 28px;
    }
  }

  .markIconZ {
    color: #f1be33;
    left: 25%;
  }
  .markIconL {
    color: #9ef133;
    left: 50%;
  }
  .markIconY {
    color: #28d200;
    left: 75%;
  }
  .markItem {
    width: 25%;
    display: inline-block;
    position: relative;
    float: left;
    text-align: center;
    font-size: 24px;
  }
  .markItem::before {
    content: "";
    width: 100%;
    height: 15px;
    background: #000;
    position: absolute;
    left: 0;
    top: -40px;
  }
  .markItem:nth-child(1) {
    color: #d45353;
  }
  .markItem:nth-child(2) {
    color: #f1be33;
  }
  .markItem:nth-child(3) {
    color: #9ef133;
  }
  .markItem:nth-child(4) {
    color: #28d200;
  }
  .markItem:nth-child(1):before {
    background: #d45353;
    color: #d45353;
  }
  .markItem:nth-child(2):before {
    background: #f1be33;
    color: #f1be33;
  }
  .markItem:nth-child(3):before {
    background: #9ef133;
    color: #9ef133;
  }
  .markItem:nth-child(4):before {
    background: #28d200;
    color: #28d200;
  }
}
.markText {
  margin-top: -30px;
  margin-bottom: 30px;
  .markTextItem {
    margin-bottom: 10px;
  }
  .markTextItem .span1 {
    width: 50px;
    height: 32px;
    text-align: center;
    line-height: 32px;
    display: inline-block;
    font-size: 15px;
    color: #fff;
    vertical-align: middle;

    border-radius: 5px;
  }
  .markTextItem .span2 {
    margin-left: 15px;
    font-size: 24px;
    vertical-align: middle;
  }
}
</style>